/** Normalize quote client / contact_info shapes for checkout and email. */
export type QuoteContactLike = {
  name?: string
  email?: string
  phone?: string
  zip?: string
  zipCode?: string
  firstName?: string
  lastName?: string
  clientEmail?: string
  clientName?: string
}

export function normalizeQuoteContact(raw: QuoteContactLike | null | undefined) {
  if (!raw) {
    return { name: '', email: '', phone: '', zipCode: '' }
  }
  const name =
    raw.name?.trim() ||
    raw.clientName?.trim() ||
    [raw.firstName, raw.lastName].filter(Boolean).join(' ').trim()
  const email = raw.email?.trim() || raw.clientEmail?.trim() || ''
  const phone = raw.phone?.trim() || ''
  const zipCode = raw.zipCode?.trim() || raw.zip?.trim() || ''
  return { name, email, phone, zipCode }
}
